import side0 from './rubberPuzzle/sideMat_0.png';


import corner0 from './rubberPuzzle/cornerMat_0.png';

export const puzzleImages = {
	side0, corner0,
}